var inProgress = {};
var dataWebpackPrefix = "__auiRuntime:";
// loadScript function to load a script via script tag
__webpack_require__.l = (url, done, key, chunkId) => {
	if(inProgress[url]) { inProgress[url].push(done); return; }
	var script, needAttach;
	if(key !== undefined) {
		var scripts = document.getElementsByTagName("script");
		for(var i = 0; i < scripts.length; i++) {
			var s = scripts[i];
			if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
		}
	}
	if(!script) {
		needAttach = true;

		// the raw chunkId is used as a web-resource key.
		// webpack5's jsonp loader will call the load function with a prefixed chunkId.
		// see https://github.com/webpack/webpack/blob/master/lib/web/JsonpChunkLoadingRuntimeModule.js#L181
		const chunkId = (key || '').replace(/^chunk-/,'');
		// use WRM.require instead of webpack's url-based lookup.
		// since WRM.require can handle in-progress loads itself, we don't need to worry about
		// registering the 'done' callback in the inProgress array; we just call it after WRM does its thing.
		// ------
		// WATCHMODE - In watch mode a batch file is loaded that contains a script that loads the actual contents from a webpack dev server.
		// This means we cant execute the "done" callback for webpack before the second script is loaded.
		// The solution is to check for all scripts to the dev-server in "performance" as this will only contain already fully loaded scripts and
		// calculate the diff to all scripts in the body. Any script that is not showing up in "performance" will be listened to for a load event.
		// Only once all those load events are successfully returned do we call the "done" callback to webpack and prevent a range of errors that
		// would be triggered otherwise.

		WRM.require('wrc!com.atlassian.auiplugin:' + chunkId).then(() => done(), (data) => {
		    var e = new Event('missing');
		    e.data = data;
		    done(e);
		});
		// we don't want the rest of the normal load function to run.
		return;
	}
	inProgress[url] = [done];
	var onScriptComplete = (prev, event) => {
		// avoid mem leaks in IE.
		script.onerror = script.onload = null;
		clearTimeout(timeout);
		var doneFns = inProgress[url];
		delete inProgress[url];
		script.parentNode && script.parentNode.removeChild(script);
		doneFns && doneFns.forEach((fn) => (fn(event)));
		if(prev) return prev(event);
	}
	var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
	script.onerror = onScriptComplete.bind(null, script.onerror);
	script.onload = onScriptComplete.bind(null, script.onload);
	needAttach && document.head.appendChild(script);
};